import MESSAGE from 'messages/message'
import PRODUCTION from 'messages/production'

export const getMessage = (messageKey, parameter) => {
  if (sessionStorage.getItem('FW_BO_MESSAGE_STORAGE') === null) {
    mergeMessage()
  }
  const MESSAGE = JSON.parse(getSessionMessage())
  const message = MESSAGE[messageKey]
  if (!message) {
    return messageKey
  }
  if (!parameter) {
    return message
  }
  return Object.keys(parameter).reduce((acc, key) => {
    return acc.replaceAll(`{${key}}`, parameter[key])
  }, message)
}

const mergeMessage = () => {
  sessionStorage.setItem('FW_BO_MESSAGE_STORAGE', JSON.stringify(Object.assign(MESSAGE, PRODUCTION)))
}

const getSessionMessage = () => {
  return sessionStorage.getItem('FW_BO_MESSAGE_STORAGE')
}
